{
    "Profile_Drivers_CancellationReason.cancellation": "FR: Cancellation",
    "Profile_Drivers_CancellationReason.cancellationDetails": "FR: Cancellation Details",
    "Profile_Drivers_CancellationReason.dateOfCancellation": "FR: Date of Cancellation",
    "Profile_Drivers_CancellationReason.cancellationReason": "FR: Cancellation Reason"
}
